import { FC, useEffect } from 'react'

import { useAppDispatch } from 'hooks/store'
import { setTitle } from 'reducers/activecourse/activecourseSlice'

import { ComeBackLaterBtn, ComeBackLaterText } from './styles'

interface CourseTabSecondComeBackLaterProps {
  title: string
}

const CourseTabSecondComeBackLater: FC<CourseTabSecondComeBackLaterProps> = ({
  title
}) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setTitle(title))
  }, [])

  const handleClickFirstCourse = () => {
    const tab = document.querySelector<HTMLAnchorElement>(
      'a[id$="-first-course"]'
    )

    tab?.click()
  }

  return (
    <ComeBackLaterText data-testid='course-tab-come-back-later-content'>
      After your attorney files your case, you may take the second financial
      education course. Until then, make sure you have completed the{' '}
      <ComeBackLaterBtn
        variant='link'
        onClick={handleClickFirstCourse}
        data-testid='course-tab-come-back-later-first-course-button'
      >
        first course
      </ComeBackLaterBtn>
      .
    </ComeBackLaterText>
  )
}

export default CourseTabSecondComeBackLater
